import { parseISO, format } from 'date-fns'
import { getDateTimeDisplayValue } from '@/store/helperModules/common.module'

const buildTableData = (dataValues) => {
  const data = !dataValues.jobList ? [] : dataValues.jobList.map((job) => {
    return {
      Values: [
        job.schedulerID,
        job.name,
        job.schedulerTypeName,
        job.performType,
        format(parseISO(job.createdDate), 'MMM dd, yyyy'),
        job.runTimeString,
        getDateTimeDisplayValue(job.lastRunTime),
        'VasionEllipsisIcon',
      ],
      ValueType: 'String',
    }
  })
  const tableData = {
    Columns: dataValues.columns,
    Rows: {
      Values: data,
      ValueType: 'ApiArray`1',
    },
  }
  return tableData
}

export {
  buildTableData,
}
